var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19615_48387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0975 17.5V15.8333C15.0975 14.9493 14.7463 14.1014 14.1212 13.4763C13.4961 12.8512 12.6482 12.5 11.7642 12.5H5.09749C4.21344 12.5 3.36559 12.8512 2.74047 13.4763C2.11535 14.1014 1.76416 14.9493 1.76416 15.8333V17.5M20.0975 17.5V15.8333C20.0969 15.0948 19.8511 14.3773 19.3986 13.7936C18.9461 13.2099 18.3126 12.793 17.5975 12.6083M14.2642 2.60833C14.9812 2.79192 15.6167 3.20892 16.0705 3.79359C16.5244 4.37827 16.7707 5.09736 16.7707 5.8375C16.7707 6.57764 16.5244 7.29673 16.0705 7.88141C15.6167 8.46608 14.9812 8.88308 14.2642 9.06667M11.7642 5.83333C11.7642 7.67428 10.2718 9.16667 8.43083 9.16667C6.58988 9.16667 5.09749 7.67428 5.09749 5.83333C5.09749 3.99238 6.58988 2.5 8.43083 2.5C10.2718 2.5 11.7642 3.99238 11.7642 5.83333Z",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19615_48387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.930664)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersSvg);
export default __webpack_public_path__ + "static/media/UsersSvg.e2ebafc846cc566306082576bb600969.svg";
export { ForwardRef as ReactComponent };